<div class="dashboard-container">
  <h1>Organização - Estatísticas</h1>

  <div class="dashboard-card">
    <h2>Quantidade de Atendimentos Realizados</h2>
    <div class="metric-value">{{ totalFinishedEncounters }}</div>
    <h2>Quantidade de Atendimentos Planejados</h2>
    <div class="metric-value">{{ plannedEncounters }}</div>
    <h2>Quantidade de Consultas Realizadas</h2>
    <div class="metric-value">{{ totalConsultationEncounters }}</div>
    <h2>Quantidade de Exames Realizados</h2>
    <div class="metric-value">{{ totalExaminationEncounters }}</div>
  </div>

  <!-- <div class="dashboard-card">
    <h2>Faturamento Total</h2>
    <div class="metric-value">{{ totalAmountInvoiced }}</div>
    <h2>Faturamento Somente de Consultas</h2>
    <div class="metric-value">{{ totalExaminationAmountInvoiced }}</div>
    <h2>Faturamento Somente de Exames</h2>
    <div class="metric-value">{{ totalConsultationAmountInvoiced }}</div>
  </div> -->

  <div class="dashboard-card">
    <h2>Quantidade de Atendimentos por Consulta ou Exame</h2>
    <mat-form-field appearance="fill">
      <mat-label>Tipo de atendimento</mat-label>
      <mat-select [(value)]="selectedAppointmentType" (selectionChange)="updateAppointmentType()">
        <mat-option value="Consulta">Consulta</mat-option>
        <mat-option value="Exame">Exame</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="metric-value">{{ totalEncountersByType[selectedAppointmentType] }}</div>
    <canvas id="appointmentTypesChart"></canvas>
  </div>

  <div class="dashboard-card">
    <h2>Quantidade de Atendimentos Planejados por Consulta ou Exame</h2>
    <mat-form-field appearance="fill">
      <mat-label>Tipo de atendimento</mat-label>
      <mat-select [(value)]="selectedPlannedAppointmentType" (selectionChange)="updateAppointmentType()">
        <mat-option value="Consulta">Consulta</mat-option>
        <mat-option value="Exame">Exame</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="metric-value">{{ totalPlannedEncountersByType[selectedPlannedAppointmentType] }}</div>
  </div>

  <div class="dashboard-card">
    <h2>Quantidade de Agendamentos Realizados (Por período)</h2>
    <mat-form-field appearance="fill">
      <mat-label>Período</mat-label>
      <mat-select [(value)]="selectedPeriod" (selectionChange)="onPeriodChange()">
        <mat-option value="daily">Diário</mat-option>
        <mat-option value="weekly">Semanal</mat-option>
        <mat-option value="monthly">Mensal</mat-option>
        <mat-option value="yearly">Anual</mat-option>
        <mat-option value="custom">Customizado</mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="selectedPeriod === 'custom'">
      <mat-form-field appearance="fill">
        <mat-label>Data Início</mat-label>
        <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="startDate" (dateChange)="onCustomDateChange()" />
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Data Fim</mat-label>
        <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="endDate" (dateChange)="onCustomDateChange()" />
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="metric-value">{{ totalEncounters }}</div>
  </div>

  <div class="dashboard-card">
    <h2>Quantidade de Atendimentos Realizados por Especialista</h2>
    <mat-form-field appearance="fill">
      <mat-label>Selecione o especialista</mat-label>
      <mat-select [(value)]="doctorName">
        <mat-option *ngFor="let doctor of encountersByDoctor | keyvalue" [value]="doctor.key">{{ doctor.key }}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="metric-value">{{ encountersByDoctor[doctorName] }}</div>
  </div>

  <div class="dashboard-card">
    <h2>Quantidade de Agendamentos concluídos por Secretária</h2>
    <mat-form-field appearance="fill">
      <mat-label>Selecione a secretária</mat-label>
      <mat-select [(value)]="secretaryName">
        <mat-option *ngFor="let secretary of encountersBySecretary | keyvalue" [value]="secretary.key">{{ secretary.key }}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="metric-value">{{ encountersBySecretary[secretaryName] }}</div>
  </div>

  <div class="dashboard-card">
    <h2>Quantidade de Agendamentos por Plano de Saúde</h2>
    <mat-form-field appearance="fill">
      <mat-label>Selecione o plano</mat-label>
      <mat-select [(value)]="planName">
        <mat-option *ngFor="let plan of encountersByHealthPlan | keyvalue" [value]="plan.key">{{ plan.key }}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="metric-value">{{ encountersByHealthPlan[planName] }}</div>
  </div>

  <div class="dashboard-card">
    <h2>Quantidade de Agendamentos Cancelados</h2>
    <div class="metric-value">{{ totalCanceledEncounters }}</div>
    <div class="cancellation-rate">Taxa de Cancelamento: {{ (totalCanceledEncounters / totalFinishedEncounters) * 100 | number : '1.0-0' }}%</div>
  </div>
</div>

<div class="dashboard-card trentGraph">
  <h2 align="center">Tendência de Agendamentos ao Longo do Tempo</h2>
  <canvas id="appointmentTrendChart"></canvas>
</div>
